import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/v2',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getCountriesList = async () => {
  try {
    const all = [];
    let offset = 0;
    while (true) {
      const response = await apiClient.get('/sources/nederlandwereldwijd/infotypes/countries', {
        params: { output: 'json', offset },
      });
      const page = response.data;
      all.push(...page);
      if (page.length < 25) break;
      offset += 25;
    }
    return all;
  } catch (error) {
    console.error('Error fetching countries:', error);
    throw error;
  }
};

export const getCountryTravelAdvice = async (isocode) => {
  try {
    const response = await apiClient.get(
      `/sources/nederlandwereldwijd/infotypes/countries/${isocode.toLowerCase()}/traveladvice`,
      { params: { output: 'json' } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching travel advice:', error);
    throw error;
  }
};
